import React, { memo } from "react";
import Dialog from "@material-ui/core/Dialog";

// styles
import "bodycodi/cmap/app/css/common/requestUploadAlert.css";

const RequestUploadAlert = ({ open, setOpen, header, body, buttonLabel, onClick, onCancel }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className="alert-pop"
      classes={{ paper: "request-upload-alert" }}
    >
      <div className="request-upload-alert-header">
        <span>{header}</span>
      </div>
      <div className="request-upload-alert-body">{body}</div>
      <div className="request-upload-alert-button-wrapper">
        <button className="request-upload-alert-button" onClick={onCancel}>
          {"아니오"}
        </button>
        <button className="request-upload-alert-button" onClick={onClick}>
          {buttonLabel}
        </button>
      </div>
    </Dialog>
  );
};

export default memo(RequestUploadAlert);
